module.exports = "/lucky-balls/video/intro_rs.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/video/intro_rs.mp4
// module id = 890
// module chunks = 0